<template>
  <div class="write-off">
    <div class="exchange">
      <img src="@/assets/img/write_off_img.png" />
      <p>友情提示：此兑换二维码，仅供管理员处理使用</p>
      <h2>大救星用户福利兑换</h2>
      <el-form ref="dataForm" :model="dataForm" :rules="rules">
        <el-form-item prop="code">
          <el-input placeholder="输入验证码" v-model="dataForm.code" />
          <el-button
            @click="sendVerificationCode"
            :disabled="isSendingCode || countdown > 0"
          >
            {{ countdown > 0 ? `重新发送(${countdown})` : '获取验证码' }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="btn" @click="onSubmit">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getCode, getExchangeInfo } from '@/api/activity'
export default {
  name: 'WriteOff',
  data() {
    return {
      dataForm: {
        // phone: '13426049530',
        phone: '18612362614',
        code: '',
        id: '',
      },
      isSendingCode: false,
      countdown: 0,
      rules: {
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      id: '',
    }
  },
  mounted() {
    document.title = '核销'
    this.id = this.$route.query.id
  },
  methods: {
    // 发送验证码，调验证码接口
    async sendVerificationCode() {
      let data = {
        phone: this.dataForm.phone,
      }
      let res = await getCode(data)
      if (res.code == '1000') {
        this.isSendingCode = true
        // 设置倒计时时间，这里假设为10秒
        this.countdown = 60
        // 倒计时效果
        const countdownInterval = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(countdownInterval)
            this.isSendingCode = false
          }
        }, 1000)
      }
    },
    async exchangeInfo() {
      this.dataForm.id = this.id
      let res = await getExchangeInfo(this.dataForm)
      if (res.code == '1000') {
        localStorage.setItem('information', JSON.stringify(res.data))
        this.$router.push({
          path: '/writeOffInformation',
        })
      }
    },
    // 确定
    onSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.exchangeInfo()
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
@supports (
    (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top))
  )
  and (-webkit-overflow-scrolling: touch) {
  body {
    /* 适配齐刘海 */
    padding-top: 20px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);

    /* 适配底部小黑条 */
    padding-bottom: 0;
    padding-bottom: costant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.exchange {
  height: 100vh;
  overflow: hidden;
  background-color: white;
  padding: 0 5vw;
  img {
    display: block;
    width: 72.28vw;
    height: 32.25vh;
    margin: 3vh auto 4vh;
  }
  p {
    text-align: center;
    font-size: 4vw;
    margin-bottom: 4vh;
    color: #e8757c;
    border: 1px dashed #e8757c;
    width: 100%;
    height: 5vh;
    line-height: 5vh;
    border-radius: 3px;
  }
  h2 {
    text-align: left;
    margin: 7vh 0 4vh;
    font-size: 5vw;
  }
  .el-form-item:nth-of-type(1) {
    width: 100%;
    height: 7vh;
    background: #f8f8f8;
    border-radius: 5vw;
  }
  .el-input {
    width: 65%;
    height: 7vh;
    line-height: 7vh;
  }
  .el-button {
    background: none;
    border: none;
    color: #333;
    width: 33%;
    height: 7vh;
    padding: 0;
  }
  .el-button.is-disabled {
    background: none;
    border: none;
    color: #666;
  }
  .btn {
    display: block;
    background: url('~@/assets/img/btn_bg.png') no-repeat;
    background-size: 100% 100%;
    width: 50.7vw;
    height: 8.325vh;
    border: none;
    margin: 4vh auto;
    color: #fffbf5;
    text-shadow: 0px 2px 0px rgba(10, 31, 62, 0.15);
    font-size: 5.72vw;
    border-radius: 18.5vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/writeOff.vue